import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { GARDEN_TIPS, IMAGES } from "@/lib/content";
import { Leaf } from "lucide-react";

export default function Garten() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section
      id="garten"
      data-testid="section-garten"
      className="relative py-20 md:py-32 bg-cream-alt"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-[3rem] shadow-card aspect-[4/5]">
              <motion.img
                src={IMAGES.garden}
                alt="Igel in einer grünen Wiese"
                style={{ y }}
                className="absolute inset-0 w-full h-[110%] object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <ChapterLabel index={1} label="Garten igelfreundlich machen" color="text-brand-green" />
            <Reveal className="mt-6">
              <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight">
                Ein kleines Paradies für Igel
              </h2>
              <p className="mt-4 text-lg md:text-xl leading-relaxed text-ink-muted max-w-xl">
                Mit diesen einfachen Handgriffen findet ein Igel bei dir Schutz,
                Nahrung und einen sicheren Unterschlupf.
              </p>
            </Reveal>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {GARDEN_TIPS.map((tip, i) => (
                <Reveal
                  key={tip.title}
                  delay={i * 0.06}
                  data-testid={`garden-tip-${i + 1}`}
                  className="rounded-2xl bg-white p-6 shadow-soft border border-ink/5"
                >
                  <span className="w-10 h-10 rounded-full bg-brand-green/12 flex items-center justify-center">
                    <Leaf className="w-5 h-5 text-brand-green" />
                  </span>
                  <h3 className="mt-4 font-heading font-bold text-lg text-ink">
                    {tip.title}
                  </h3>
                  <p className="mt-2 text-base leading-relaxed text-ink-muted">
                    {tip.text}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
